export default __webpack_public_path__ + "static/media/error.f907f73f.svg";